// @ts-nocheck
import { useEffect, useRef } from "react";

import ShopifyBuy from "@shopify/buy-button-js";
import styles from "./ShopifyBuyButton.module.css";

const shopifyClient = ShopifyBuy.buildClient({
  domain: process.env.NEXT_PUBLIC_SHOPIFY_DOMAIN,
  storefrontAccessToken: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_AT,
  storefrontApiVersion: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION,
});

const shopifyOptions = {
  product: {
    iframe: false,
    layout: "vertical",
    templates: {
      img: null,
      imgWithCarousel: null,
      title: null,
      variantTitle: null,
      options: null,
      price: null,
      description: null,
      button: `
      <button class="{{data.classes.product.button}} {{data.buttonClass}}" data-element="product.button">
        Toevoegen aan winkelmandje
      </button>
    `,
      quantity: null,
      buttonWithQuantity: null,
    },
  },
  cart: {
    startOpen: false,
    contents: {
      discounts: false,
      footer: true,
      lineItems: true,
      note: false,
      title: true,
    },
    text: {
      button: "Afrekenen",
      currency: "EUR",
      empty: "Je winkelmandje is leeg",
      noteDescription: null,
      notice: "Afrekenen gebeurt bij onze partner Shopify.",
      title: "Winkelmandje",
      total: "Totaal",
    },
    styles: {
      cart: {
        "font-family": "'franklin-gothic-urw', sans-serif",
      },
      button: {
        "background-color": "#39b54a",
      },
    },
  },
  toggle: {
    styles: {
      toggle: {
        "background-color": "#39b54a",
        ":hover": {
          "background-color": "#209c31",
        },
      },
    },
  },
};

const ShopifyBuyButton = ({ productId }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    if (!window.shopifyUI) {
      window.shopifyUI = ShopifyBuy.UI.init(shopifyClient);
    }

    window.shopifyUI.createComponent("cart", {
      moneyFormat: "€{{amount}}",
      options: shopifyOptions,
    });

    if (productId) {
      window.shopifyUI.createComponent("product", {
        id: productId,
        moneyFormat: "€{{amount}}",
        node: containerRef.current,
        options: shopifyOptions,
      });
    }
  }, [productId]);

  return (
    <div className={styles.container}>
      <div ref={containerRef} />
    </div>
  );
};

export default ShopifyBuyButton;
